import { Button, Checkbox, Col, Row } from 'antd';

import CardMaterial from 'materials/CardMaterial';
import React from 'react';
import SpinMaterial from 'materials/SpinMaterial';
import { Field, Form } from 'react-final-form';
import InputDatePicker from 'components/InputDatePicker';
import SelectField from 'components/SelectField';
import moment from 'moment-timezone';

export default function AttendenceReportComponent(props: any) {
  const {
    setPosko,
    listPosko = [],
    listCourier = [],
    handleDownload,
    isLoading,
  } = props;
  const initialValues = React.useMemo(
    () => ({
      dateAbsensi: null,
      isMonth: false,
      courier: [],
    }),
    []
  );
  return (
    <div style={{ paddingBottom: '35px' }}>
      <SpinMaterial
        spinning={isLoading}
        size={'large'}
        content={
          <CardMaterial
            extra={''}
            title={<b className="titleCard">LAPORAN ABSENSI</b>}
            style={{ borderRadius: '10px' }}
            content={
              <Form
                onSubmit={() => {}}
                initialValues={initialValues}
                validate={values => {
                  const { dateAbsensi, posko, courier } = values;
                  const errors: any = {};
                  if (!dateAbsensi) errors.dateAbsensi = 'Tanggal wajib diisi';
                  if (!posko) errors.posko = 'HUB wajib diisi';
                  if (courier?.length === 0)
                    errors.courier = 'Kurir wajib diisi';
                  return errors;
                }}
              >
                {(formProps: any) => {
                  const { values, invalid, pristine, form } = formProps;
                  const { isMonth } = values;
                  const formatDate = 'YYYY-MM-DD';
                  const minDate = (d: any) =>
                    !d ||
                    d.isBefore('2020-01-01') ||
                    d.isAfter(
                      moment(new Date()).add(1, 'day').format(formatDate)
                    );

                  return (
                    <div>
                      <Row gutter={[36, 24]}>
                        <Col span={12}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'end',
                            gap: '12px',
                            marginBottom: '24px',
                          }}>
                            <Col span={18} style={{padding: '0px'}}>
                              <Field name="dateAbsensi">
                                {({ input, meta }) => (
                                  <InputDatePicker
                                    label="Tanggal Absensi"
                                    placeholder="Pilih tanggal"
                                    format={formatDate}
                                    error={
                                      meta.error && meta.touched && meta.error
                                    }
                                    onBlur={input.onBlur}
                                    value={input.value}
                                    onChange={value => input.onChange(value)}
                                    onCalendarChange={value =>
                                      input.onChange(value)
                                    }
                                    disabledDate={minDate}
                                    mode={isMonth ? 'month' : 'date'}
                                  />
                                )}
                              </Field>
                            </Col>
                            <Col span={6}>
                              <Field name="isMonth" type="checkbox">
                                {({ input }) => (
                                  <Checkbox {...input} value={true}>
                                    Bulanan
                                  </Checkbox>
                                )}
                              </Field>
                            </Col>
                          </div>
                          <div style={{ marginBottom: '24px' }}>
                            <Field name="courier">
                              {({ input, meta }) => (
                                <SelectField
                                  label="Kurir"
                                  placeholder="Pilih Kurir"
                                  mode="multiple"
                                  disabled={!values.posko}
                                  allowClear
                                  data={[
                                    ...(Array.isArray(listCourier) &&
                                    listCourier?.length === input.value.length
                                      ? []
                                      : listCourier?.length !== 0
                                      ? [
                                          {
                                            id: 'SetAllCourier',
                                            name: 'Pilih Semua Kurir',
                                          },
                                        ]
                                      : []),
                                    ...(Array.isArray(listCourier)
                                      ? listCourier
                                      : []),
                                  ]}
                                  onBlur={input.onBlur}
                                  value={input.value}
                                  onChange={value => {
                                    if (
                                      value &&
                                      value.includes('SetAllCourier')
                                    ) {
                                      const allIds = listCourier?.map(
                                        (data: any) => data.id
                                      );
                                      return input.onChange(allIds);
                                    }
                                    return input.onChange(value);
                                  }}
                                  validate
                                  validateStatus={
                                    meta.error && meta.touched
                                      ? 'error'
                                      : 'validating'
                                  }
                                  errorMessage={
                                    meta.error && meta.touched && meta.error
                                  }
                                />
                              )}
                            </Field>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div style={{ marginBottom: '24px'}}>
                            <Field name="posko">
                              {({ input, meta }) => (
                                <SelectField
                                  label="HUB"
                                  placeholder="Pilih HUB"
                                  data={listPosko}
                                  value={input.value}
                                  validate
                                  onChange={value => {
                                    setPosko(value);
                                    input.onChange(value);
                                  }}
                                  onBlur={value => input.onBlur(value)}
                                  validateStatus={
                                    meta.error && meta.touched
                                      ? 'error'
                                      : 'validating'
                                  }
                                  errorMessage={
                                    meta.error && meta.touched && meta.error
                                  }
                                />
                              )}
                            </Field>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <div className={'spacingDownloadButton'}>
                          <Button
                            type="danger"
                            shape="round"
                            size="default"
                            style={{
                              height: '35px',
                              width: '100px',
                              marginRight: '16px',
                            }}
                            disabled={pristine!}
                            onClick={() => {
                              form.reset();
                              setPosko(undefined);
                            }}
                          >
                            <b>Reset</b>
                          </Button>
                          <Button
                            type="primary"
                            shape="round"
                            size="default"
                            style={{
                              height: '35px',
                              width: '100px',
                            }}
                            disabled={invalid}
                            onClick={() => handleDownload(values)}
                          >
                            <b>Download</b>
                          </Button>
                        </div>
                      </Row>
                    </div>
                  );
                }}
              </Form>
            }
          />
        }
      />
    </div>
  );
}
